/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-22 13:41:31
 * @LastEditors: K
 * @LastEditTime: 2022-09-09 17:20:55
 */
import { unwrapResult } from '@reduxjs/toolkit';
import { Row, Col, Table, Radio, Spin } from 'antd';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../../app/store';
import { ActiveInstitutionsLine, DoctorLine, UploadOutlined } from '../../../compnents/icons/Icons';
import { getBackgroundColor, getOrganizationPlaneName } from '../../../models/monitoring';
import { UpdateTime } from '../components/time';
import { getTableList, getTendencyChart, getUserAllData, getUserDoctorPie } from '../monitoringPageSlice';
import styles from '../monitoringTab.module.css'
import * as echarts from 'echarts';
import { echartsLine, echartsPie } from '../../../models/echartsData';
import { title } from 'process';

interface UserDataProps {
  state: string
}

export const UserData = ({ state }: UserDataProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const pieRefA = useRef<HTMLDivElement>(null)

  const pieRefB = useRef<HTMLDivElement>(null)

  const pieRefC = useRef<HTMLDivElement>(null)

  const lineRef = useRef<HTMLDivElement>(null)

  const [dataNum, setDataNum] = useState(0)    //全部or好医点or聚网

  const list = [{ name: 'doctorNum', title: 'newDoctorNum', color: 1, icon: <DoctorLine /> }, { name: 'activeDoctorNum', title: 'newActiveDoctorNum', color: 2, icon: <ActiveInstitutionsLine /> }]

  const [listData, setListData] = useState<any>({})

  const [pieChartData, setPieChartData] = useState<any>({})    //各省机构分布图数据

  const [listLoading, setListLoading] = useState(false) // 全部、好医点、聚网 loading

  const [lineChartData, setLineChartData] = useState<any>()    //近一年医生趋势图数据

  const pieList = [{
    id: 0,
    el: pieRefA,
    name: 'tenantDoctorPieChart',
    title: 'q'
  }, {
    id: 1,
    el: pieRefB,
    name: 'doctorPieSexChartVO',
    title: 'r'
  }, {
    id: 2,
    el: pieRefC,
    name: 'doctorAgeChartVO',
    title: 's'
  }]

  const getDoctorLineChart = () => { //近一年医生趋势图
    dispatch(getTendencyChart({
      trendChartType: 1,
      type: dataNum
    }))
      .then(unwrapResult)
      .then((t: any) => setLineChartData(t))
  }


  useEffect(() => {   // 全部、好医点、聚网
    setListLoading(true)
    dispatch(getUserAllData({ type: dataNum }))
      .then(unwrapResult)
      .then((res: any) => setListData(res))
      .finally(() => setListLoading(false))
    dispatch(getUserDoctorPie({ type: dataNum }))
      .then(unwrapResult)
      .then((res: any) => setPieChartData(res))
    getDoctorLineChart()
  }, [dataNum])

  useEffect(() => {
    setTimeout(() => {
      pieList.forEach((v) => {
        pieEcharts(v.el, v.name, v.title)
      })
      lineEcharts()
    }, 200)
  }, [pieRefA, lineRef, pieChartData, lineChartData])

  const pieEcharts = (ref: any, name: string, title: string) => {

    if (!ref.current) return

    const myChart = echarts.init(ref?.current);
    if (!pieChartData[name]?.length) {
      myChart.dispose()
    }
    myChart.setOption(echartsPie(pieChartData[name], 'name', 'val', true, title));
  }

  const lineEcharts = () => {   
    if (!lineRef.current) return
    const myChart = echarts.init(lineRef?.current);
    myChart.setOption(echartsLine(lineChartData, true, 'doctorTrend', 1));
  }

  useEffect(() => {   //缓存tab 栏
    sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])

  return (
    <div className={styles.containers}>
      <div className={styles.content}>
        <UpdateTime time={listData?.dataTime} select={(v) => setDataNum(v)} />
        <Spin spinning={listLoading} >
        <Row gutter={20} className={styles.planContainer}>
          {
            list.map((v: any, i: number) => (
              <Col key={v.name} flex={'20%'} >
                <div className={`${styles.planItem} ${styles.layout}`}>
                  <div className={styles.planIcon}
                    style={{ backgroundColor: getBackgroundColor(v.color) }}>
                    {v.icon}
                  </div>
                  <div className={styles.planData}>
                    {getOrganizationPlaneName(v.name)}
                    {listData[v.name] && <div className={styles.titleWrap}>
                      <div className={styles.titleText}>{listData[v.name]}</div>
                      <div className={styles.titleText2}> ({listData[v.title]})</div>
                    </div>}
                  </div>
                </div>
              </Col>
            ))
          }
        </Row>
        </Spin>
        <Row gutter={20} className={`${styles.planContainer} ${styles.echartsContainer}`}>
          {
            pieList.map((v, i) => (
              <Col flex={'33.3%'} key={i} style={{ height: 340 }}>
                <div className={styles.layout}>
                  <div ref={v.el} className={styles.echartsPie}></div>

                </div>
              </Col>
            ))
          }
        </Row>
        <Row className={`${styles.planContainer}`}>
          <Col flex={1}>
            <div className={styles.layout}>
              <div ref={lineRef} className={styles.echartsLine}></div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
